import apiService from "./apiService";

const dashboardService = {
    async getCurrentScores() {
        try {
            return (await apiService.get(`score/get-recent-scorecards`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async saveOverAllScoreCards(id,scores) {
        try {
            return (await apiService.post(`score/${id}/save-event-overall-scores`, scores, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async getCurrentScoresByParams(params) {
        try {
            return (await apiService.get(`score/get-recent-scorecards-byjudgeid/${params.judgeid}/${params.eventid}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getOverAllScoreCardsByEventId(eventId) {
        try {
            return (await apiService.get(`score/get-overall-scorecards/${eventId}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },

    async setAsActive(eventId) {
        try {
            return (await apiService.put(`contest/setcurrentcontest/${eventId}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },

    async getCurrentEventJudges(eventId) {
        try {
            return (await apiService.get(`judge/getjudges-byeventid/${eventId}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getAllEvents() {
        try {
            return (await apiService.get(`contest/search`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async toggleEventStatus(id) {
        try {
            return (await apiService.post(`contest/toggle-status/${id}`, {}, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },

    async showSlider() {
        try {
            return (await apiService.post(`contest/show-slider`, {}, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },

    async allowOverride(eventId, judgeId) {
        try {
            return (await apiService.post(`contest/allow-override/${eventId}/${judgeId}`, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." }
        }
    },

    async preventOverride(eventId, judgeId) {
        try {
            return (await apiService.post(`contest/prevent-override/${eventId}/${judgeId}`, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." }
        }
    },

    async saveScores(scores) {
        const resp = (await apiService.post(`score/save-scores`, scores, true)).data;
        return resp;
    },
    async getScanningSummary(id) {
        try {
            const resp = (await apiService.get(`d/getscanningsummary/${id}`, {}, true)).data;
            if (resp === null) {
                return {
                    pending: 0,
                    partially: 0,
                    completed: 0,
                };
            }
            return resp;
        }
        catch {
            return {
                pending: 0,
                partially: 0,
                completed: 0,
            };
        }
    },
    async getDashboardBreakdown(id, page) {
        try {
            return (await apiService.get(`d/getbrgybreakdown/${id}/${page}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getDashboardVoterByStatus(id, action, page) {
        try {
            return (await apiService.get(`d/getvoterbystatus/${id}/${action}/${page}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getDashboardVoterByType(id, action, page) {
        try {
            return (await apiService.get(`d/getvoterbytype/${id}/${action}/${page}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getLatestChartMovement(cityid, timerange) {
        try {
            return (await apiService.get(`d/getvotermc/${cityid}/${timerange}`, {}, true)).data;
        }
        catch {
            return [];
        }
    }
};

export default dashboardService;